(() => {
  const openArabicGuide = () => {
    if (location.hash === '#mc-arabic-guide') {
      const guide = document.getElementById('mc-arabic-guide');
      if (guide) guide.open = true;
    }
  };
  const initialize = () => {
    openArabicGuide();
    document.querySelectorAll('[data-mc-comparison]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const select = section.querySelector('[data-mc-compare-size]');
      const copy = section.querySelector('[data-mc-compare-copy]').dataset;
      const cards = [...section.querySelectorAll('[data-mc-compare-card]')].map(card => ({
        card,
        variants: JSON.parse(card.querySelector('[data-mc-variants]').textContent),
        initialPrice: card.querySelector('[data-mc-compare-price]').textContent
      }));
      const normalize = value => value.toLowerCase().replace(/[×x]/g, 'x').replace(/\s+/g, '');
      const sizes = new Map();
      cards.forEach(({variants}) => variants.forEach(v => sizes.set(normalize(v.title), v.title)));
      [...sizes].sort((a,b) => a[1].localeCompare(b[1], 'fr', {numeric:true})).forEach(([value,label]) => {
        select.add(new Option(label, value));
      });
      section.querySelector('[data-mc-compare-controls]').hidden = false;
      select.addEventListener('change', () => {
        const selected = select.value;
        section.querySelector('[data-mc-compare-note]').textContent = selected
          ? `${copy.selected} ${select.selectedOptions[0].textContent}` : copy.note;
        cards.forEach(({card, variants, initialPrice}) => {
          const variant = variants.find(v => normalize(v.title) === selected);
          card.querySelector('[data-mc-compare-price]').textContent = selected ? (variant?.price || '—') : initialPrice;
          card.querySelector('[data-mc-compare-status]').textContent = !selected ? '' : !variant ? copy.unavailable : variant.available ? copy.available : copy.soldOut;
          card.querySelectorAll('[data-mc-compare-link]').forEach(link => {
            const url = new URL(card.dataset.productUrl, location.origin);
            if (selected && variant) url.searchParams.set('variant', variant.id);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) url.searchParams.set('preview_theme_id', preview);
            link.href = url.pathname + url.search;
          });
        });
      });
    });
    const labels = document.querySelector('[data-mc-policy-labels]');
    if (labels) {
      const titles = JSON.parse(labels.textContent);
      document.querySelectorAll('.shopify-policy__title h1').forEach(title => {
        const key = title.textContent.trim().toLowerCase();
        if (titles[key]) title.textContent = titles[key];
      });
    }
  };
  document.addEventListener('variant:update', event => {
    const variant = event.detail?.resource;
    const section = event.target.closest('.shopify-section');
    if (!variant || !section || !section.querySelector('.product-details')) return;
    section.querySelectorAll('[data-mc-product-wa]').forEach(link => {
      const message = `${link.dataset.messageIntro} ${link.dataset.productTitle}, ${variant.title}. ${link.dataset.productUrl}?variant=${variant.id}`;
      const url = `https://wa.me/212669171057?text=${encodeURIComponent(message)}`;
      link.href = url;
      const floating = document.querySelector('[data-mc-floating-wa]');
      if (floating) floating.href = url;
    });
  });
  window.addEventListener('hashchange', openArabicGuide);
  document.addEventListener('click', event => {
    if (event.target.closest('a[href="#mc-arabic-guide"]')) {
      const guide = document.getElementById('mc-arabic-guide');
      if (guide) guide.open = true;
    }
  });
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
